/// <amd-module name="Core/Medius.Core.Web/Scripts/shared/mediaService"/>

import { getMigratedUrlIfNeeded } from "../Helpers/migrationApisHelper";

export function getImageUrl(imageHash: string, imageType: string) {
    if (!imageHash || !imageType) {
        return undefined;
    }

    const url = `Backend/Rest/MediaService/image/${imageHash}/png/pages/1?tag=${imageType}`;
    return getMigratedUrlIfNeeded(url, (s:string) => s);
}